<template>
  <div id="app">
    <Auth />
    <div style="position: fixed; top:120px; left:160px;">
        <h1>Comparar Curso</h1>
        <img src="@/assets/img-course-thumb-default.png" width="90%" />
        <h1 style="color:white" >R$ 60,00</h1>
    
    </div>
    <el-tabs
      style="border-radius: 10px"
      class="table"
      type="card"
      @tab-click="handleClick"
      v-model="activeName"
    >
      <!-- <el-tab-pane label="Login" name="login">
        <UserFormLogin />
      </el-tab-pane> -->

      <el-tab-pane label="Virar Aluno" name="register">
        <NewStudent />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script lang="ts">
export default {
  data() {
    return {
      activeName: 'register',
    };
  },
  mounted() {
    // console.log(this.$route.query.name);
  },
  methods: {},
};
</script>


<style scoped>
#app {
  display: flex;
  width: 100vw;
  height: 120vh;
  justify-content: center;
  align-items: start;
  background-color: #1226aa;
  margin-block-start: 78px;
  justify-content: space-evenly;
}
.table {
  width: 40vw;
  padding: 20px;
  background-color: #fff;
}
.avatar {
  display: flex;
  justify-content: center;
  align-items: center;
}
.grid-content {
  border-right: 1px solid rgba(224, 230, 237, 0.5);
}
.content-center {
  display: flex;
  height: 20vh;
  align-items: center;
}
@media screen and (min-width: 200px) {
  .table {
    width: 100vw;
  }
}
@media screen and (min-width: 660px) {
  .table {
    width: 80vw;
  }
}
@media screen and (min-width: 1200px) {
  .table {
    width: 60vw;
  }
}
@media screen and (min-width: 1600px) {
  .table {
    width: 50vw;
  }
}
</style>